'use strict';

const _=require('pulsar-utils/dist-es6/_');
const DashboardStatus=require('pulsar-dashboard-core/dist-es6/domain/dashboardStatus');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const moment=require('pulsar-utils/dist-es6/time/moment');
const ex=require('pulsar-utils/dist-es6/ex');let

Formatters=class Formatters{
static intervalDurationAsHours(interval,options){
return Formatters.timeSpanAsHoursAndMinutes(interval.duration,options)+' h';
}

static timeSpanAsHoursAndMinutes(timespan,options){
const hours=Math.floor(timespan.totalHours());

if(_.get(options,'colonless')){
return`${hours}h ${timespan.minutes}m`;
}

const leadingZeroes=_.get(options,'leadingZeroes');

return`${leadingZeroes?_.padStart(hours,leadingZeroes,'0'):hours}:${_.padStart(timespan.minutes,2,'0')}`;
}

static timeSpanAsMinutesAndSeconds(timespan){
const minutes=Math.floor(timespan.totalMinutes());
return`${minutes}:${_.padStart(timespan.seconds,2,'0')}`;
}

static humanizedTimeSince(earlier,later){
return moment(earlier).from(later,!0);
}

static humanizedTimeUntil(earlier,later){
return moment(earlier).to(later,!0);
}

static drivingIntervalLabel(trip){
return`Driving\n${Formatters.intervalDurationAsHours(trip)}`;
}

static dutyLabel(duty,use24Hour){
return`On Duty\n${Formatters.intervalInLocationTimeAmPm(duty,!0,use24Hour)}`;
}

static dutyLabelWithDefaultTimeZone(timeZone,use24Hour){
return duty=>Formatters.dutyLabel({
start:duty.start,
end:duty.end,
startTimezone:duty.startTimezone||timeZone,
endTimezone:duty.endTimezone||timeZone},
use24Hour);
}

static dutyLabelWithDefaultTimeZone_24Hour(timeZone){
return Formatters.dutyLabelWithDefaultTimeZone(timeZone,!0);
}

static sleepLabel(sleepInterval,use24Hour,title='Sleep'){
return`${title} (${Formatters.timeSpanAsHoursAndMinutes(sleepInterval.duration,{colonless:!0})})\n${Formatters.intervalInLocationTimeAmPm(sleepInterval,!0,use24Hour)}`;
}

static sleepLabelWithDefaultTimeZone(timeZone,use24Hour,title){
return sleepInterval=>Formatters.sleepLabel({
start:sleepInterval.start,
end:sleepInterval.end,
duration:sleepInterval.duration,
startTimezone:sleepInterval.startTimezone||timeZone,
endTimezone:sleepInterval.endTimezone||timeZone},
use24Hour,title);
}

static sleepLabelWithDefaultTimeZone_24Hour(timeZone,title){
return Formatters.sleepLabelWithDefaultTimeZone(timeZone,!0,title);
}

static tripLabel(use24Hour,seperator='\n'){
return trip=>`${trip.origin.description} to ${trip.destination.description}${seperator}${Formatters.intervalInLocationTimeAmPm(trip,!0,use24Hour)}`;
}

static tripLabel_24Hour(){
return Formatters.tripLabel(!0);
}

static flightLabel(use24Hour,seperator='\n'){
return flight=>`${flight.origin.description} to ${flight.destination.description}${seperator}${Formatters.intervalInLocationTimeAmPm(flight,!0,use24Hour)}`;
}

static flightLabel_24Hour(){
return Formatters.flightLabel(!0);
}

static deviationLabel(deviation){
if(!_.exists(deviation)){
return'--';
}
return deviation>=0?`+${deviation}`:deviation;
}

static intervalInComputerTimeMilitary(interval){
const start=interval.start.toTimeString().substr(0,5);
const end=interval.end.toTimeString().substr(0,5);

return`${start} - ${end}`;
}

static intervalInLocationTimeAmPm(interval,displayTimeZone,use24Hour){
const start=Formatters.timeInLocale(interval.start,interval.startTimezone,displayTimeZone,use24Hour);
const end=Formatters.timeInLocale(interval.end,interval.endTimezone,displayTimeZone,use24Hour);

return`${start} - ${end}`;
}

static timeInLocale(time,timezone,displayTimeZone=!0,use24Hour=!1){
return Formatters.formatInLocale(time,_getHourFormat(use24Hour),timezone,{displayTimeZone});
}

static monthDayYearInUtc(time){
if(!_.exists(time)){
return'--';
}

return _momentExpectingDate(time).utc().format('MM / DD / YYYY');
}

static monthDayAndTimeInLocale(time,timezone,options){
return Formatters.formatInLocale(time,'MMM DD, h:mm A',timezone,options);
}

static formatInLocale(time,format,timezone,options={}){
if(!_.exists(timezone)){
const offset=time.getTimezoneOffset()/-60;
return _momentExpectingDate(time).format(format)+` (GMT${offset>=0?'+':''}${offset})`;
}

let _timeString=format?_momentExpectingDate(time).tz(timezone).format(format):'';

if(!options.displayTimeZone){
return _timeString;
}

return _timeString+` (${Formatters.timezoneInLocale(time,timezone)})`;
}

static timezoneInLocale(time,timezone){
const fixPosixStrings=/Etc\/GMT/.exec(timezone)!==null;
const formattingString=(fixPosixStrings?'[GMT]':'')+'z';
const formatted=_momentExpectingDate(time).tz(timezone).format(formattingString);

return fixPosixStrings?
formatted.replace(/GMT([-+])0/,'GMT$1'):
formatted;
}

static overallTripLabel(trip){
return`${trip.origin.city}, ${trip.origin.state} to ${trip.destination.city}, ${trip.destination.state}`;
}

static utcAxisTimeLabel(time){

const format=time.getUTCHours()%12==0?'h A':'h:mm';
return _momentExpectingDate(time).utc().format(format);
}

static utcAxisTimeLabel_24Hour(time){
return _momentExpectingDate(time).utc().format(_getHourFormat(!0));
}

static localAxisTimeLabel(time){
return _momentExpectingDate(time).format(_getHourFormat(!1));
}

static timeAndFullDateInTimeZone(time,timezone,use24Hour=!1){
return Formatters.formatInLocale(time,
`${_getHourFormat(use24Hour)} MMM D, YYYY`,
timezone,
{displayTimeZone:!1});
}

static timeAndFullDateInTimeZone_24Hour(time,timezone){
return Formatters.timeAndFullDateInTimeZone(time,timezone,!0);
}

static timeAndFullDateInLocalTimeWithoutZone(time){
return _momentExpectingDate(time).format('h:mm A MMM D, YYYY');
}

static formatFatigue(number,placeholder='--'){
if(number>=50){
return'50+';
}

return ex(DashboardStatus.truncateFatigue(number)).otherwise(placeholder);
}

static roundUpToInteger(number){
if(!_.exists(number)){
return void 0;
}

return Math.ceil(number);
}

static classFromThresholdStatus(thresholdStatus){
switch(thresholdStatus){
case ThresholdStatus.At:
return AtThresholdClassObject;
case ThresholdStatus.Above:
return AboveThresholdClassObject;}

}

static dutyStatusFromLastKnownStatus(lastKnownStatus){
let{onDuty,onTrip}=lastKnownStatus;
return onDuty&&onTrip?'Driving':onDuty?'On duty':'Off duty';
}

static cityStateFromLastKnownStatus(lastKnownStatus){
let{location}=lastKnownStatus;
return`${location.city}, ${location.stateCode}`;
}

static dayOfWeekInTimeZone(time,timezone){
return Formatters.formatInLocale(time,'ddd',timezone,{displayTimeZone:!1});
}

static monthAndDayInTimeZone(time,timezone,{fullMonth=!1,dayFirst=!1,includeYear=!1}={}){
let dayFormat='DD';
let monthFormat=fullMonth?'MMMM':'MMM';

let dayAndMonthFormat=dayFirst?`${dayFormat} ${monthFormat}`:`${monthFormat} ${dayFormat}`;

if(includeYear){
dayAndMonthFormat+=', YYYY';
}

return Formatters.formatInLocale(time,dayAndMonthFormat,timezone,{displayTimeZone:!1});
}

static heatmapShortName(personOrGroup,maxChars=3){
if(personOrGroup.name.length<=maxChars){
return personOrGroup.name;
}

const nameToSplit=_.exists(personOrGroup,'firstName')&&_.exists(personOrGroup,'lastName')?
`${personOrGroup.firstName[0]} ${personOrGroup.lastName}`:
personOrGroup.name;

return nameToSplit.split(/\W+/g).slice(0,maxChars).map(s=>s[0]).join('').toUpperCase();
}

static pluralizableCount(baseLabel,count){
let result=`${count} ${baseLabel}`;
if(count!==1){
result+='s';
}
return result;
}

static fixedPercentOrNothing(count,total){
if(total===0){
return'';
}
return`${(count/total*100).toFixed(2)}%`;
}

static valueWithPercentage(...args){
const[count,totalCount,label='Event']=_.isString(args[1])?[args[0],void 0,args[1]]:args;
let result=`${Formatters.pluralizableCount(label,count)}`;

if(_.exists(totalCount)&&totalCount!==0){
result=`${result} (${Formatters.fixedPercentOrNothing(count,totalCount)})`;
}

return result;
}};


const AtThresholdClassObject={"at-threshold":!0};
const AboveThresholdClassObject={"above-threshold":!0};

const _momentExpectingDate=time=>{
if(moment.isMoment(time)){
return time;
}

if(!_.isDate(time)){
throw new Error('Formatter expects time argument to be a moment or Date!');
}

return moment(time);
};

const TwentyFourHourFormat='HH:mm';

const _getHourFormat=use24Hour=>use24Hour?TwentyFourHourFormat:'h:mm A';

module.exports=Formatters;
module.exports.TwentyFourHourFormat=TwentyFourHourFormat;
//# sourceMappingURL=formatters.js.map
